module.exports = __webpack_public_path__ + "static/home_sky_bg-008ea8f14984afa9fba9d33abcf26d8e.svg";